var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "con-exemple-prompt", attrs: { id: "resourceForm" } },
    [
      _c("div", { staticClass: "vx-row mb-6" }, [
        _vm._m(0),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "vx-col sm:w-2/3 w-full" },
          [
            _vm.type != "show"
              ? _c("vs-input", {
                  staticClass: "w-full",
                  attrs: { name: "title", size: "large" },
                  model: {
                    value: _vm.resource.title,
                    callback: function ($$v) {
                      _vm.$set(_vm.resource, "title", $$v)
                    },
                    expression: "resource.title",
                  },
                })
              : _c("b", [_vm._v(_vm._s(_vm.resource.title))]),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "vx-row mb-6" }, [
        _vm._m(1),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "vx-col sm:w-2/3 w-full" },
          [
            _vm.type != "show"
              ? [
                  _c(
                    "div",
                    {
                      ref: "tooltip",
                      attrs: {
                        "data-toggle": "tooltip",
                        "data-placement": "top",
                        title:
                          "Cette donnée permet de catégoriser vos question. Vous pouvez sélectionner une valeur existante ou en ajouter une nouvelle.",
                      },
                    },
                    [
                      _c("TypeForm", {
                        attrs: { availableTypes: _vm.types.data },
                        model: {
                          value: _vm.resource.type,
                          callback: function ($$v) {
                            _vm.$set(_vm.resource, "type", $$v)
                          },
                          expression: "resource.type",
                        },
                      }),
                    ],
                    1
                  ),
                ]
              : _c("span", [_vm._v(_vm._s(_vm.resource.type))]),
          ],
          2
        ),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "mb-10" },
        [
          _c(
            "vs-collapse",
            { staticClass: "mb-6 mt-10", attrs: { accordion: "" } },
            [
              _c("vs-collapse-item", [
                _c("div", { attrs: { slot: "header" }, slot: "header" }, [
                  _c("h5", [_vm._v("Signification des réponses : ")]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "vx-row" }, [
                  _c(
                    "div",
                    {
                      staticClass:
                        "vx-col sm:w-2/5 w-full flex items-center justify-start",
                    },
                    [_c("b", [_vm._v("0 - Pas du tout d'accord : ")])]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "input-level vx-col sm:w-3/5 w-full" },
                    [
                      _vm.type == "show"
                        ? _c("span", [
                            _vm._v(_vm._s(_vm.resource.levels.level_0)),
                          ])
                        : _c("vs-input", {
                            staticClass: "w-full",
                            attrs: {
                              name: "levels_level_0",
                              placeholder: "0 : ",
                              type: "text",
                            },
                            model: {
                              value: _vm.resource.levels.level_0,
                              callback: function ($$v) {
                                _vm.$set(_vm.resource.levels, "level_0", $$v)
                              },
                              expression: "resource.levels.level_0",
                            },
                          }),
                    ],
                    1
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "vx-row mt-3" }, [
                  _c(
                    "div",
                    {
                      staticClass:
                        "vx-col sm:w-2/5 w-full flex items-center justify-start",
                    },
                    [_c("b", [_vm._v("1 - Plutôt pas d'accord : ")])]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "input-level vx-col sm:w-3/5 w-full" },
                    [
                      _vm.type == "show"
                        ? _c("span", [
                            _vm._v(_vm._s(_vm.resource.levels.level_1)),
                          ])
                        : _c("vs-input", {
                            staticClass: "w-full",
                            attrs: {
                              name: "levels_level_1",
                              placeholder: "1 : ",
                              type: "text",
                            },
                            model: {
                              value: _vm.resource.levels.level_1,
                              callback: function ($$v) {
                                _vm.$set(_vm.resource.levels, "level_1", $$v)
                              },
                              expression: "resource.levels.level_1",
                            },
                          }),
                    ],
                    1
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "vx-row mt-3" }, [
                  _c(
                    "div",
                    {
                      staticClass:
                        "vx-col sm:w-2/5 w-full flex items-center justify-start",
                    },
                    [_c("b", [_vm._v("2 - Plutôt d'accord : ")])]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "input-level vx-col sm:w-3/5 w-full" },
                    [
                      _vm.type == "show"
                        ? _c("span", [
                            _vm._v(_vm._s(_vm.resource.levels.level_2)),
                          ])
                        : _c("vs-input", {
                            staticClass: "w-full",
                            attrs: {
                              name: "levels_level_2",
                              placeholder: "2 : ",
                              type: "text",
                            },
                            model: {
                              value: _vm.resource.levels.level_2,
                              callback: function ($$v) {
                                _vm.$set(_vm.resource.levels, "level_2", $$v)
                              },
                              expression: "resource.levels.level_2",
                            },
                          }),
                    ],
                    1
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "vx-row mt-3" }, [
                  _c(
                    "div",
                    {
                      staticClass:
                        "vx-col sm:w-2/5 w-full flex items-center justify-start",
                    },
                    [_c("b", [_vm._v("3 - Tout à fait d'accord : ")])]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "input-level vx-col sm:w-3/5 w-full" },
                    [
                      _vm.type == "show"
                        ? _c("span", [
                            _vm._v(_vm._s(_vm.resource.levels.level_3)),
                          ])
                        : _c("vs-input", {
                            staticClass: "w-full",
                            attrs: {
                              name: "levels_level_3",
                              placeholder: " 3 : ",
                              type: "text",
                            },
                            model: {
                              value: _vm.resource.levels.level_3,
                              callback: function ($$v) {
                                _vm.$set(_vm.resource.levels, "level_3", $$v)
                              },
                              expression: "resource.levels.level_3",
                            },
                          }),
                    ],
                    1
                  ),
                ]),
              ]),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "vx-row mb-6" }, [
        _vm._m(2),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "vx-col sm:w-4/5 w-full pl-8 pr-12" },
          [
            _vm.type != "show"
              ? _c("avatar-cropper", {
                  attrs: {
                    id: "cropper",
                    trigger: "#edited-pick-photo",
                    labels: { submit: "Soumettre", cancel: "Annuler" },
                    "upload-handler": _vm.submitPhoto,
                    "cropper-options": {
                      aspectRatio: "16:9",
                      autoCropArea: 1,
                      viewMode: 1,
                      movable: false,
                      zoomable: false,
                    },
                  },
                })
              : _vm._e(),
            _vm._v(" "),
            _c(
              "div",
              {
                staticStyle: {
                  "text-align": "center",
                  "font-size": "20px",
                  "background-color": "grey",
                  color: "white",
                  width: "470px",
                  height: "36px",
                },
                attrs: { id: "edited-pick-photo" },
              },
              [
                _c("small", [
                  _vm._v(
                    "Cliquez pour Modifier/Ajouter la photo avec un fichier"
                  ),
                ]),
              ]
            ),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "vx-row mb-6" }, [
        _vm._m(3),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "vx-col sm:w-4/5 w-full pl-8 pr-12" },
          [
            _vm.type != "show"
              ? _c("vs-input", {
                  staticClass: "w-full",
                  attrs: { name: "resourcePhoto" },
                  model: {
                    value: _vm.resource.photo,
                    callback: function ($$v) {
                      _vm.$set(_vm.resource, "photo", $$v)
                    },
                    expression: "resource.photo",
                  },
                })
              : _vm._e(),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "vx-row mb-6" }, [
        _vm._m(4),
        _vm._v(" "),
        _c("div", { staticClass: "vx-col sm:w-4/5 w-full pl-8 pr-12" }, [
          !_vm.isVideoFile(_vm.resource.photo)
            ? _c("img", {
                attrs: {
                  id: "edited-pick-photo",
                  src: _vm.resource.photo,
                  width: "120px",
                },
              })
            : _c("iframe", {
                attrs: {
                  width: "100%",
                  height: "315",
                  src: _vm.resource.photo,
                  title: "Video player",
                  frameborder: "0",
                  allow:
                    "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture",
                  allowfullscreen: "",
                },
              }),
        ]),
      ]),
      _vm._v(" "),
      _vm.isASuperAdmin()
        ? _c("div", { staticClass: "vx-row mb-6" }, [
            _vm._m(5),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "vx-col sm:w-4/5 w-full pl-8 pr-12" },
              [
                _vm.resource.audio_description
                  ? _c(
                      "div",
                      { staticClass: "w-full flex items-center mb-2" },
                      [
                        _c("audio", { attrs: { controls: "" } }, [
                          _c("source", {
                            attrs: {
                              src: _vm.resource.audio_description,
                              type: "audio/mp3",
                            },
                          }),
                          _vm._v(
                            "\n                    Your browser does not support the audio element.\n                "
                          ),
                        ]),
                        _vm._v(" "),
                        _vm.type != "show"
                          ? _c(
                              "div",
                              { staticClass: "ml-5" },
                              [
                                _c(
                                  "vs-button",
                                  {
                                    attrs: { color: "danger" },
                                    on: {
                                      click: () =>
                                        (_vm.resource.audio_description = null),
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n                        Supprimer l'audio\n                    "
                                    ),
                                  ]
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.type != "show"
                  ? _c("vs-input", {
                      staticClass: "w-full",
                      attrs: {
                        name: "audio_description",
                        type: "file",
                        accept: "audio/mp3, .mp3",
                        danger: this.fileError.message,
                        "danger-text": this.fileError.message,
                      },
                      on: { change: _vm.setAudioDescription },
                    })
                  : _vm._e(),
              ],
              1
            ),
          ])
        : _vm._e(),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "vx-col sm:w-1/3 w-full" }, [
      _c("span", [_vm._v("Libellé* :")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "vx-col sm:w-1/3 w-full" }, [
      _c("span", [_vm._v("Type* :")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "vx-col sm:w-1/5 w-full pl-12" }, [
      _c("span", [_vm._v("Image (.jpg, .png, .webp) :")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "vx-col sm:w-1/5 w-full pl-12" }, [
      _c("span", [
        _vm._v(
          "Lien vers une image du savoir-faire (lien public, libre de droits): "
        ),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "vx-col sm:w-1/5 w-full pl-12" }, [
      _c("span", [_vm._v("Aperçu :")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "vx-col sm:w-1/5 w-full pl-12" }, [
      _c("span", [_vm._v("Description audio (*.mp3)")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }